var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypeAzure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/Apps/Azure@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.9762325%",
    y1: "7.4114724%",
    x2: "37.1841038%",
    y2: "103.76182%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0669BC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "59.7237125%",
    y1: "52.3127289%",
    x2: "52.6927812%",
    y2: "54.8636556%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.3,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.2,
    offset: "7.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.1,
    offset: "32.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.05,
    offset: "62.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "37.2725685%",
    y1: "4.60005789%",
    x2: "62.4796378%",
    y2: "99.9794963%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2892DF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/34px/Apps/Azure"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#F1F4FB",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons/18px/Amazon/Color",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.946447, 8.969870)",
    id: "azure"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.66732543,0.000193148152 L10.6977763,0.000193148152 L5.47567449,15.4688492 C5.36562172,15.7947736 5.05991326,16.0142996 4.71583259,16.0142996 L0.800898382,16.0142996 C0.542958556,16.0142996 0.300796051,15.890143 0.150343056,15.6806797 C-0.000109938293,15.4712164 -0.0404311601,15.2021242 0.0420224658,14.9577792 L4.90729034,0.54564353 C5.01729927,0.21957555 5.32312267,0 5.66732543,0 L5.66732543,0.000193148152 Z",
    id: "Path",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.977302,10.3755322 L5.00021786,10.3755322 C4.84844802,10.3753647 4.71203679,10.4680697 4.65635567,10.6092212 C4.60067454,10.7503728 4.63706839,10.9112115 4.74809641,11.0146597 L9.87398638,15.7977805 C10.0232264,15.936961 10.2197318,16.0142996 10.4238237,16.0142996 L14.9407582,16.0142996 L12.977302,10.3755322 Z",
    id: "Path",
    fill: "#0078D4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66732543,0.000187236558 C5.31902257,-0.0011431341 5.01034512,0.224182736 4.90555157,0.556266679 L0.0480115578,14.9446451 C-0.0400187761,15.1899586 -0.00294553297,15.46277 0.14735858,15.6757117 C0.297662693,15.8886533 0.542336626,16.0150038 0.803023544,16.0143025 L4.81899953,16.0143025 C5.1235104,15.9599058 5.37519432,15.7459174 5.47779965,15.45417 L6.44648698,12.6000197 L9.90663659,15.8265596 C10.0516361,15.946466 10.2335304,16.0127664 10.4216985,16.0143025 L14.921825,16.0143025 L12.9481294,10.3755324 L7.1945439,10.3768845 L10.7159368,0.000187236558 L5.66732543,0.000187236558 Z",
    id: "Path",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.092462,0.544870938 C11.9826084,0.219328206 11.6772414,0.000193148152 11.3335861,0.000193148152 L5.72721635,0.000193148152 C6.07085251,0.000193148152 6.37618838,0.219365374 6.48609227,0.544870938 L11.3515533,14.9575861 C11.4340692,15.2019757 11.3937849,15.4711398 11.2433319,15.6806797 C11.0928789,15.8902196 10.8506795,16.0144928 10.5926774,16.0144928 L16.1992403,16.0144928 C16.4572083,16.0144928 16.6993501,15.8901316 16.8497579,15.6806013 C17.0001658,15.4710709 17.040428,15.2019434 16.957923,14.9575861 L12.092462,0.544870938 Z",
    id: "Path",
    fill: "url(#linearGradient-5)",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeAzure);
export default __webpack_public_path__ + "static/media/type-azure.9b177b2b26b00c1ed426dcd7dcb6c3b0.svg";
export { ForwardRef as ReactComponent };